import { render } from "./Adrs.vue?vue&type=template&id=98e22ec4&scoped=true"
import script from "./Adrs.vue?vue&type=script&lang=js"
export * from "./Adrs.vue?vue&type=script&lang=js"

import "./Adrs.vue?vue&type=style&index=0&id=98e22ec4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e22ec4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QTooltip,QPagination});
